export var CountryExtractor = {
    id: function (item) { return item.id; },
    name: function (item) { return item.name; },
};
